import { css } from '@/styled-system/css';

export const upsellCloseButtonStyles = css.raw({
  position: 'absolute',
  insetBlockStart: 'Upsell.CloseButton.margin.top',
  insetInlineEnd: 'Upsell.CloseButton.margin.right',
});
